import React from 'react'
import classnames from 'classnames'
import { TransitionGroup } from 'react-transition-group';

import { Box, List, ListItem, Collapse } from '@mui/material'
import { NOOP, getStyle } from '@fedsim/helpers'

import { Actions } from '../../actions'
import { GenericItem } from '../items'

import { useListStyles } from './generic.list.style'

export function GenericList(props) {
  const {
    activeIndex = -1,
    actions = [],
    className = '',
    collection = [],
    itemStyle = getStyle,
    onClick = NOOP,
    PresentationItem = GenericItem
  } = props
  const styles = useListStyles()
  if (collection.length === 0) {
    return null
  }
  return (
    <List disablePadding className={classnames(className, styles.root)}>
      <TransitionGroup>
        {collection.map((item, index) => {
          const key = item?.id ? item.id : index
          const selected = activeIndex === index
          const payload = item?.id ? item.id : item
          const singleClick = () => onClick(payload, index)
          const style = itemStyle(item) || {}
          if (!item) return
          return (
            <Collapse key={key}>
              <ListItem
                role='listitem'
                divider
                style={style}
                className={classnames({ [styles.listItem]: true, [styles.selected]: selected })}
              >
                <Box className={styles.container}>
                  <Box
                    onClick={singleClick}
                    className={styles.presentation}
                  >
                    <PresentationItem {...item} index={index} />
                  </Box>
                  {actions.length > 0 && (
                    <Box className={styles.actions}>
                      <Actions
                        actions={actions}
                        payload={item}
                        size="small"
                        orientation='horizontal'
                      />
                    </Box>
                  )}
                </Box>
              </ListItem>
            </Collapse>
          )
        })}
      </TransitionGroup>
    </List>
  )
}
